// extracted by mini-css-extract-plugin
export default {"title":"Settings_title__-CdTy","header":"Settings_header__sS2By"};